<table mat-table class="mat-elevation-z8 table-auto" [dataSource]="dataSource">
  <ng-container *ngIf="enableMerge && !readOnly" matColumnDef="$select">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell class="pr-2 align-top" *matCellDef="let element">
      <mat-checkbox
        *ngIf="!element.isNew && hasElementsToMerge"
        [checked]="selection.isSelected(element)"
        (change)="selection.toggle(element)"></mat-checkbox>
    </td>
  </ng-container>
  <ng-container *ngIf="enableEntityStatus" matColumnDef="$entityStatus">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell class="pr-2" style="text-align: right" *matCellDef="let element">
      <mat-icon
        *ngIf="element.isNew && !element.isCeased"
        matTooltip="New/Undo"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:plus-circle'"
        (click)="delete(element)"></mat-icon>
      <mat-icon
        *ngIf="element.isModified && !element.isCeased"
        matTooltip="Modified/Undo"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:pencil'"
        (click)="undo(element)"></mat-icon>
      <mat-icon
        *ngIf="element.isDeleted && !element.isCeased"
        matTooltip="Deleted/Undo"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:minus-circle'"
        (click)="undoDelete(element)"></mat-icon>
      <mat-icon
        *ngIf="!element.isDeleted && element.isCeased"
        matTooltip="Ceased"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
      <mat-icon
        *ngIf="element.isDuplicate"
        matTooltip="Duplicate"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
    </td>
  </ng-container>

  <ng-container *ngIf="enableDelete && !readOnly" matColumnDef="$action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell class="pr-2 align-top" *matCellDef="let element">
      <mat-icon
        *ngIf="!element.isDeleted && !element.isNew && !element.isCeased"
        matTooltip="Delete"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:trash'"
        (click)="delete(element)"></mat-icon>
      <mat-icon
        *ngIf="enableMerge && element.isNew && selection.hasValue()"
        matTooltip="Merge"
        matTooltipPosition="above"
        [svgIcon]="'heroicons_outline:square-2-stack'"
        (click)="merge(element)"></mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns">
    <th mat-header-cell class="pr-4" *matHeaderCellDef>
      {{ display(column) }}
    </th>
    <td mat-cell class="pr-4 align-top" *matCellDef="let element">
      <ng-container *ngIf="enableEntityStatus && (element.isDeleted || element.isCeased); else NotDeleted">
        <ng-container [ngSwitch]="type(element, column)">
          <ng-container *ngSwitchCase="'boolean'">
            <div class="flex flex-col flex-auto">
              <span class="text-gray-300">{{ element[column] ? "Yes" : "No" }}</span>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'DateTime'">
            <div class="flex flex-col flex-auto">
              <span class="text-gray-300">{{ element[column] | date: "shortDate" }}</span>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="flex flex-col flex-auto">
              <span
                class="text-gray-300"
                *ngIf="longValueName(column); else Default"
                [matTooltip]="element[longValueName(column)]"
                matTooltipPosition="above"
                >{{ element[column] }}</span
              >
              <ng-template #Default>
                <span class="text-gray-300">{{ element[column] }}</span>
              </ng-template>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #NotDeleted [ngSwitch]="type(element, column)">
        <ng-container *ngIf="!readOnly; else ReadOnly">
          <ng-container [ngSwitch]="type(element, column)">
            <ng-container *ngSwitchCase="'DateTime'">
              <div class="flex flex-col flex-auto">
                <mat-form-field
                  class="pt-2"
                  floatLabel="never"
                  [matTooltip]="element[column] | date: 'shortDate'"
                  matTooltipPosition="above">
                  <input
                    matInput
                    [matDatepicker]="datepicker"
                    [placeholder]="display(column)"
                    [(ngModel)]="element[column]" />
                  <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>Cancel</button>
                      <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                </mat-form-field>
                <span
                  class="text-red-400 text-sm italic"
                  *ngIf="enableEntityStatus && element.isModified && element.originalValues[column] !== undefined"
                  >Was: {{ element.originalValues[column] | date: "shortDate" }}</span
                >
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="flex flex-col flex-auto">
                <mat-form-field
                  class="pt-2"
                  floatLabel="never"
                  [matTooltip]="element[column]"
                  matTooltipPosition="above">
                  <input
                    matInput
                    [placeholder]="display(column)"
                    [value]="element[column]"
                    [(ngModel)]="element[column]" />
                </mat-form-field>
                <span
                  class="text-red-400 text-sm italic"
                  *ngIf="enableEntityStatus && element.isModified && element.originalValues[column] !== undefined"
                  >Was: {{ element.originalValues[column] }}</span
                >
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #ReadOnly [ngSwitch]="type(element, column)">
          <ng-container *ngSwitchCase="'boolean'">
            <div class="flex flex-col flex-auto">
              <span>{{ element[column] ? "Yes" : "No" }}</span>
              <span
                class="text-red-400 text-sm italic"
                *ngIf="enableEntityStatus && element.isModified && element.originalValues[column] !== undefined"
                >Was: {{ element.originalValues[column] ? "Yes" : "No" }}</span
              >
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'DateTime'">
            <div class="flex flex-col flex-auto">
              <span>{{ element[column] | date: "shortDate" }}</span>
              <span
                class="text-red-400 text-sm italic"
                *ngIf="enableEntityStatus && element.isModified && element.originalValues[column] !== undefined"
                >Was: {{ element.originalValues[column] | date: "shortDate" }}</span
              >
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="flex flex-col flex-auto">
              <span
                *ngIf="longValueName(column); else Default"
                [matTooltip]="element[longValueName(column)]"
                matTooltipPosition="above"
                >{{ element[column] }}</span
              >
              <ng-template #Default>
                <span>{{ element[column] }}</span>
              </ng-template>
              <ng-container *ngIf="longValueName(column); else NoTooltip">
                <span
                  class="text-red-400 text-sm italic"
                  [matTooltip]="element.originalValues[longValueName(column)]"
                  matTooltipPosition="above"
                  *ngIf="enableEntityStatus && element.isModified && element.originalValues[column] !== undefined"
                  >Was: {{ element.originalValues[column] }}</span
                >
              </ng-container>
              <ng-template #NoTooltip>
                <span
                  class="text-red-400 text-sm italic"
                  *ngIf="enableEntityStatus && element.isModified && element.originalValues[column] !== undefined"
                  >Was: {{ element.originalValues[column] }}</span
                >
              </ng-template>
            </div>
          </ng-container>
        </ng-template>
      </ng-template>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
  <tr
    [ngClass]="{
      hidden: row.isDetached,
      'bg-green-100': !row.isDeleted && !row.isCeased && row.isNew,
      'bg-yellow-100': !row.isDeleted && !row.isCeased && row.isModified,
      'bg-red-100': !row.isDeleted && !row.isCeased && !row.isMatch
    }"
    mat-row
    *matRowDef="let row; columns: allColumns"></tr>
</table>
